export function first(array) {
    return array.length ? array[0] : null;
}

export function last(array) {
    return array.length ? array[array.length - 1] : null;
}

export function flatten<T>(array: T[][]): T[] {
    return Array.prototype.concat.apply([], array);
}

export function sum(array: number[]): number {
    return array.reduce((s, n) => s + n, 0);
}

export function difference<T>(left: T[], right: T[]): T[] {
    const keys = left.reduce((map, key) => map.add(key), new Set<T>());
    for (const key of right) {
        keys.delete(key);
    }
    return Array.from(keys);
}

export function groupBy<TKey, TValue>(keySelector: (_: TValue) => TKey, values: TValue[]): Map<TKey, TValue[]> {
    const groups = new Map<TKey, TValue[]>();
    for (const value of values) {
        const key = keySelector(value);
        if (!groups.has(key)) {
            groups.set(key, []);
        }
        const group = groups.get(key);
        group.push(value);
    }
    return groups;
}